import BarNormalDefault from '../../lib/jin/svgchartlib/01_Charts/03_Bar_Normal/includes/primitives/Data'

export default BarNormalDefault